import { SettingPannelController } from "@quest/murka-games-behavior-panther/dist";

export class SettingPanelController extends SettingPannelController {
    //
}
